import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { LoadingButton } from '@mui/lab';
import { Button, CardContent, DialogTitle, ListItemIcon, Paper, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { CommonHelper } from 'src/utils/commonHelper';

const GoogleMyBusinessAuthorizationModal = (props) => {
  const { t: translate } = useTranslation();
  const [isLoadingOn, setLoadingOn] = useState(false);
  const isCustomDomain = CommonHelper.CustomDomain();
   const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");

  const handleConnectGoogleMyBusiness = () => {
    setLoadingOn(true);
    props.handleConnectGoogleMyBusiness();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title">
        <Typography gutterBottom variant="h4">
          {props.reAuth
            ? `${translate('integration.google_my_business.reauthenticate_google_my_business')}`
            : `${translate('integration.google_my_business.converted_your_google_my_business')}?`}
        </Typography>
        {(!isCustomDomain || isPortalAdmin)&& (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Button
              variant="outlined"
              startIcon={<YouTubeIcon />}
              onClick={() => window.open('https://www.youtube.com/watch?v=p8Kcm7zC7tE', '_blank')}
              color="primary"
            >
              {translate('common.tutorial')}
            </Button>
          </Box>
        )}
      </DialogTitle>
      <DialogContent dividers>
        <CardContent sx={{ p: { xs: 0, md: 0 }, color: 'grey.800' }}>
          <Typography variant="body1" sx={{ mx: 'auto', fontWeight: 'bold' }}>
            {props.reAuth
              ? `${translate('common.verify_these_requirements')}`
              : `${translate('common.make_sure_completed_steps')}:`}
          </Typography>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">{translate('integration.youtube.confirm_google_account')}</Typography>
          </Paper>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {translate('integration.google_my_business.verify_google_my_business')}
            </Typography>
          </Paper>

          {!props.reAuth && (
            <>
              <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                <ListItemIcon>
                  <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
                </ListItemIcon>
                <Typography variant="body1">
                  {translate('integration.google_my_business.copyrights_or_privacy')}
                </Typography>
              </Paper>
            </>
          )}
        </CardContent>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={() => {
            handleConnectGoogleMyBusiness();
          }}
        >
          {props.reAuth ? translate('common.reconnect') : translate('common.connect')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default GoogleMyBusinessAuthorizationModal;
